import React from "react";
import Styles from "./style.module.scss";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { IPhoto, PhotoPostPage, PropsPhotos } from "../../types";
import Photo from "./components/Photo/Photo";
import classNames from "classnames/bind";
import { deletePhoto } from "../../redux/Reducers/photoSlice";
import { useLocation } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { MButton } from "../Button";
import { animationBtnMorePhotos, framerMotionPhotosAndPackets } from "../../helpers/framerMotion";

const Photos: React.FC<PropsPhotos> = ({ photoPostPage, onClick, hide, buttonName }) => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const { showPhotos, categoryPhotosBtn } = useAppSelector((state) => state.photos);
  const cx = classNames.bind(Styles);
  const styleContainPhotos = cx("photos", { photos__gallery: photoPostPage === PhotoPostPage.photoGalleryPage });
  const isGallery = photoPostPage === PhotoPostPage.photoGalleryPage;
  const prefersReducedMotion = useReducedMotion();

  const { container, item } = framerMotionPhotosAndPackets(0.15);

  const handleDeletePhoto = (photoId: string, arrPhoto: IPhoto[]): void => {
    const currentPhoto = arrPhoto.find((photo: IPhoto) => {
      return photo._id.includes(photoId);
    });
    dispatch(
      deletePhoto({
        photoId: currentPhoto?._id,
        path: pathname.length < 2 ? "random" : "sort",
        type: categoryPhotosBtn === null ? null : currentPhoto?.type,
      })
    );
  };

  return (
    <>
      <motion.ul
        className={styleContainPhotos}
        variants={container}
        initial={prefersReducedMotion ? false : "hidden"}
        animate="show"
      >
        {showPhotos.map((image: IPhoto, imageIndex: number) => {
          return (
            <Photo
              image={image}
              imageIndex={imageIndex}
              photoPostPage={photoPostPage}
              key={image._id}
              variants={item}
              handleDeletePhoto={handleDeletePhoto}
              showPhotos={showPhotos}
            />
          );
        })}
      </motion.ul>
      {isGallery && (
        <motion.div initial="hidden" whileInView="visible" viewport={{ amount: 0.1 }}>
          <MButton variants={animationBtnMorePhotos} styleButton="ping" onClick={onClick} type="button" hide={hide}>
            {buttonName}
          </MButton>
        </motion.div>
      )}
    </>
  );
};

export default Photos;
